export default {
    smscList: [],
    smsc: {},
    totalItems: null,
    totalPage: null
};